import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './shared/login/login.component';
import { ShopingCartComponent } from './shared/shoping-cart/shoping-cart.component';
import { PreVentaComponent } from './shared/pre-venta/pre-venta.component';
import { ProductDetailComponent } from './shared/productDetail/product-detail.component';
import { PreguntaComponent } from './shared/pregunta/pregunta.component';
import { QuienesSomosComponent } from './shared/quienes-somos/quienes-somos.component';
import { PagoSuccessComponent } from './pages/user/componentes/custom/pago-success/pago-success.component';


const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "", component: ShopingCartComponent },
  { path: "confirm", component: PreVentaComponent },
  { path: 'producto/:id', component: ProductDetailComponent },
  { path: 'success/:id', component: PagoSuccessComponent },
  { path: 'quien', component: QuienesSomosComponent },
  { path: 'pregunta', component: PreguntaComponent }


];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', // 🔹 hace scroll arriba en cada navegación
    anchorScrolling: 'enabled',           // 🔹 permite usar enlaces con #
    scrollOffset: [0, 0],
    useHash: true,
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
